import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/from'
import { TimestampTypes } from './timestampRedux'
import { WeatherTypes } from './weatherRedux'

const WEATHER_KEY = 'e4053ad41a8f6912b38a324255db85af'

const weatherUrl = (lng, lat, weatherKey = WEATHER_KEY) =>
  `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lng}&appid=${weatherKey}`

const BOUNDS_CHANGED = TimestampTypes.BOUNDS_CHANGED
const WEATHER_UPDATE_REQUESTED = WeatherTypes.WEATHER_UPDATE_REQUESTED
const WEATHER_UPDATE_FULFILLED = WeatherTypes.WEATHER_UPDATE_FULFILLED
// const WEATHER_UPDATE_FAILED = WeatherTypes.WEATHER_UPDATE_FAILED

const weatherUpdateFulfilled = json => ({
  type: WEATHER_UPDATE_FULFILLED,
  json
})

export const updateWeatherEpic = (action$, store) =>
  action$
    .ofType(WEATHER_UPDATE_REQUESTED, BOUNDS_CHANGED)
    .switchMap(() => {
      const [lng, lat] = store.getState().map.center
      return Observable.from(fetch(weatherUrl(lng, lat)))
    })
    .mergeMap(response => response.json())
  .map(json => weatherUpdateFulfilled(json))
  .catch(error => {
    console.log(error)
    return Observable.of({ type: 'ERROR' })
  })



// WEBPACK FOOTER //
// ./src/redux/weatherEpic.js